
import makerjs from "makerjs";
function A31(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  // console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,H = Param[1].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       w = W * 1 * myZoom,       
       h = H * 1 * myZoom,
     
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       r=h/2,
       x0=0,y0=0,x1=0,y1=h,x2=w,y2=h,x3=w,y3=0,
       glassH = h, glassW = w;

   if (w !== 0) {
       var TxtW = W;
   }if (h !== 0) {
    var TxtH = H;
} 
   var drawAbnormalShapeA31 = {
       paths: {
        "LeftArcLine": new makerjs.paths.Arc([x0+r,y0], [x1+r,y1],r,false,true),
        "TopLine": new makerjs.paths.Line([x1+r,y1],[x2-r,y2]),
        "RightArcLine": new makerjs.paths.Arc([x2-r,y2],[x3-r,y3],r,false,true),
        "BottomLine": new makerjs.paths.Line([x3-r,y3],[x0+r,y0]),
       }
   };
   var drawAbnormalShapeA31MarkW = {
       paths: {
        "Line": new makerjs.paths.Line([x0,y0-markShift], [x3,y3-markShift]),
        "LeftLine": new makerjs.paths.Line([x0,y0-2*markShift], [x0,y0]),
        "RithgLine": new makerjs.paths.Line([x3,y3-2*markShift], [x3,y3]),
       }
   };
   var drawAbnormalShapeA31MarkH = {
       paths: {
        "Line": new makerjs.paths.Line([x0-markShift, y0], [x1-markShift, y1]),
        "LineUp": new makerjs.paths.Line([x1-2*markShift, y1], [x1, y1]),
        "LineDn": new makerjs.paths.Line([x0-2*markShift, y0], [x0, y0]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeA31MarkW, TxtW, [x0,y0-2*markShift], [x3,y3-2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeA31MarkH, TxtH, [x0-3*markShift, y0], [x1-3*markShift, y1]);//长度文字  
   
  plate={
    models: {
      drawAbnormalShapeA31: drawAbnormalShapeA31,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA31: drawAbnormalShapeA31,
        drawAbnormalShapeA31MarkW: drawAbnormalShapeA31MarkW,
        drawAbnormalShapeA31MarkH: drawAbnormalShapeA31MarkH,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A31;